import type { AlaparForras, IngatlanTipus } from './tipusok.ts';

export const MOTOR_VERZIO = '1.4.0';

/**
 * A mai árszintet ennyi legfrissebb negyedév indexének átlaga adja (1.3.0, 2026-10-14). Az MNB 2026 júliusától a
 * legutóbbi negyedévet előzetesen közli, és a következő kiadásban javítja; egyetlen előzetes pont egy kis régióban
 * nagyot ugorhat (2026Q2, Észak-Magyarország városai: −9,8%).
 */
export const INDEX_MOST_NEGYEDEV = 2;

/** Spec 6. pont: sávszélesség a forrás szerint (±). */
export const SAV_ALAP: Record<AlaparForras, number> = { iroda: 0.08, ksh_utca: 0.1, ksh_terulet: 0.15 };
/** A KSH relatív szórásának ennyiszerese a sáv alsó határa (terv, „Eltérések” 3. pont). */
export const SZORAS_SULY = 0.5;
/** Ennél szélesebb sávot nem mutatunk; szakértői ág lesz belőle. */
export const SAV_MAX = 0.2;
/** Ennél kevesebb KSH-adásvételnél a sáv szélesebb (terv, „Eltérések” 9. pont). */
export const KEVES_UGYLET = 5;
export const KEVES_UGYLET_POTLEK = 0.05;

/** Elfogadható alapterület típusonként (m²); ezen kívül szakértői ág. */
export const MERET_HATAROK: Record<IngatlanTipus, readonly [number, number]> = {
  lakas: [15, 300],
  haz: [30, 500],
  iroda: [10, 3000],
  ipari: [50, 20000],
  telek: [100, 50000],
  garazs: [8, 80],
};

/** Ezeknél csak irodai alapárral adunk számot. */
export const CSAK_IRODAI_ARRAL: readonly IngatlanTipus[] = ['iroda', 'ipari'];

export const KEREKITES_HATAR = 30_000_000;

/**
 * Ezekre a válaszokra nem adunk számot, a lead szakértői ágra megy (`atipikus_ingatlan`; kutatás 11. pont).
 * Vályog falazatnál és bizonytalan telek-besorolásnál vagy irodakategóriánál a szabályalapú ár félrevezető lenne.
 */
export const SZAKERTOI_JELLEMZOK: readonly { tipus: IngatlanTipus; kulcs: string; ertek: string }[] = [
  { tipus: 'haz', kulcs: 'falazat', ertek: 'valyog' },
  { tipus: 'telek', kulcs: 'belterulet', ertek: 'nem_tudom' },
  { tipus: 'iroda', kulcs: 'kategoria', ertek: 'nem_tudom' },
];
